import { createActions, createReducer } from 'reduxsauce'

const { Types, Creators: ManagersActions } = createActions({
    addManager: ['body', 'callback'],
    addManagerSuccess: [],
    addManagerFailure: [],

    getManagers: [],
    getManagersSuccess: ['managers'],
    getManagersFailure: ['getManagersError'],

    updateManager: ['body', 'callback'],
    updateManagerSuccess: ['supplierAdminId', 'status'],
    updateManagerFailure: [],

    updateManagerRole: ['body', 'email', 'key', 'callback'],
    updateManagerRoleSuccess: ['body', 'email', 'key'],
    updateManagerRoleFailure: ['error'],
})

export const ManagersTypes = Types

const INITIAL_STATE = {
    loadingAddManager: false,
    loadingManagers: true,
    loadingUpdateManager: null,
    managers: [],
    getManagersError: null,
    loadingUpdateRole: null,
}

export const reducer = createReducer(INITIAL_STATE, {
    [Types.ADD_MANAGER]: state => ({ ...state, loadingAddManager: true }),
    [Types.ADD_MANAGER_SUCCESS]: state => ({ ...state, loadingAddManager: false }),
    [Types.ADD_MANAGER_FAILURE]: state => ({ ...state, loadingAddManager: false }),

    [Types.GET_MANAGERS]: state => ({ ...state, loadingManagers: true }),
    [Types.GET_MANAGERS_SUCCESS]: (state, { managers }) => ({ ...state, loadingManagers: false, managers, getManagersError: null }),
    [Types.GET_MANAGERS_FAILURE]: (state, { getManagersError }) => ({ ...state, loadingManagers: false, managers: [], getManagersError }),

    [Types.UPDATE_MANAGER]: (state, { body }) => ({ ...state, loadingUpdateManager: body.supplierAdminId }),
    [Types.UPDATE_MANAGER_SUCCESS]: (state, { supplierAdminId, status }) => ({
        ...state,
        loadingUpdateManager: null,
        managers: state.managers.map(manager => (manager.supplierAdminId === supplierAdminId ? { ...manager, status } : manager)),
    }),
    [Types.UPDATE_MANAGER_FAILURE]: state => ({ ...state, loadingUpdateManager: null }),

    [Types.UPDATE_MANAGER_ROLE]: (state, { body, email, key }) => ({
        ...state,
        loadingUpdateRole: { email: email, property: Object.keys(body)[0], key },
    }),
    [Types.UPDATE_MANAGER_ROLE_SUCCESS]: (state, { body, email, key }) => ({
        ...state,
        loadingUpdateRole: null,
        managers: state.managers.map(manager => {
            if (manager.email === email) {
                manager[key] = { ...manager[key], ...body }
            }
            return manager
        }),
    }),
    [Types.UPDATE_MANAGER_ROLE_FAILURE]: state => ({ ...state, loadingUpdateRole: null }),
})

export default ManagersActions
